export const ProductLogo = ({ product, height = 140, className = "" }) => (
  <div className={`overflow-hidden w-full flex items-center justify-center ${className}`} style={{ height }} data-testid={`product-logo-${product.id}`}>
    {product.padded ? (
      <img src={product.logo} alt={product.name} className="w-[85%] h-auto object-contain" style={{ marginTop: "-30%", marginBottom: "-30%" }} />
    ) : (
      <img src={product.logo} alt={product.name} className="h-full w-auto object-contain" />
    )}
  </div>
);
